import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';

function Contact() {
  const [showContactInfo, setShowContactInfo] = useState(true);

  return (
    <>
      <Helmet>
        <title>Contact Us | AI Chat Assist – Connect for Support & Sales</title>
        <meta
          name="description"
          content="Have questions about AI Chat Assist? Contact our team for support, demos, partnerships, or inquiries. We're here to assist you across Singapore, UK & UAE."
        />
        <meta
          name="keywords"
          content="conversational AI solutions, WhatsApp integration, Lead generation, 24/7 Customer support, ai customer service, FAQ automation"
        />
        <link rel="canonical" href="https://www.aichatassist.com/contact" />
        <meta
          property="og:title"
          content="Contact Us | AI Chat Assist – Support, Sales & Inquiries"
        />
        <meta
          property="og:description"
          content="Best intelligent conversational AI chatbot with WhatsApp integration for global brands in Singapore, the UK, and UAE. Reach out to us for demos, support, or lead generation solutions."
        />
        <meta property="og:url" content="https://www.aichatassist.com/contact" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://admin.aichatassist.com/uploads/Wordpress_Plugin_Banner_6964048f39.jpg"
        />
        <meta property="og:site_name" content="AI Chat Assist" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Us | AI Chat Assist – Support, Sales & Inquiries"
        />
        <meta
          name="twitter:description"
          content="Best intelligent conversational AI chatbot with WhatsApp integration for brands in Singapore, the UK, and UAE. Contact us for inquiries or demos."
        />
        <meta
          name="twitter:image"
          content="https://admin.aichatassist.com/uploads/Wordpress_Plugin_Banner_6964048f39.jpg"
        />
        <meta name="twitter:site" content="@aichatassist" />
      </Helmet>

      {/* Map section with contact info overlay */}
      <div className="map-container position-relative" style={{ height: '90vh' }}>
        {/* Static Map Image */}
        <div
          className="static-map-container"
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* Map Image */}
          <img
            src="/images/map.png"
            alt="AI Chat Assist Office Location"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />

          {/* No marker - using just the static map image */}
        </div>

        {/* Using the static map image without any additional markers */}

        {/* Gradient overlay - positioned to not block interaction */}
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            pointerEvents: 'none',
            background:
              'radial-gradient(circle,rgba(245, 241, 253, 0) 0%, rgba(245, 241, 253, 0.56) 100%)',
            zIndex: 1,
          }}
        ></div>

        {/* Contact Info Popup */}
        <div className={`contact-info-popup ${showContactInfo ? 'show' : ''}`}>
          <button className="toggle-btn" onClick={() => setShowContactInfo(!showContactInfo)}>
            {showContactInfo ? '×' : 'Contact'}
          </button>

          <div className="contact-content">
            <h1 className="display-5 fw-bold mb-4">
              Get in <span className="hero-highlight">Touch</span>
            </h1>

            <div className="contact-section mb-4">
              <h2 className="h4 fw-bold">Our Office</h2>
              <p className="mb-0">
                Office No.201, 2th floor, <br />
                Crossroad Building, Bhumkar Chowk Rd,
                <br />
                Shankar Kalat Nagar, Wakad, Pimpri-Chinchwad, Pune, Maharashtra 411057
              </p>
            </div>

            <div className="contact-section mb-4">
              <h2 className="h4 fw-bold">Email Us</h2>
              <p className="mb-0">support@aichatassist.com</p>
            </div>

            <div className="contact-section mb-4">
              <h2 className="h4 fw-bold">Business Hours</h2>
              <p className="mb-0">
                Monday - Friday: 9:00 AM - 6:00 PM
                <br />
                Saturday: 10:00 AM - 2:00 PM
                <br />
                Sunday: Closed
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="container py-5 contact-page">
        <div className="row">
          <div className="col-md-4">
            <div className="mb-4">
              <h3 className="display-6 fw-bold mb-0">Frequently asked questions.</h3>
            </div>
          </div>
          <div className="col-md-8">
            <div className="accordion" id="contactFaq">
              {/* <div className="accordion-item border-0 mb-3 shadow-sm">
                <h3 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    How can I get in touch with your team?
                  </button>
                </h3>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#contactFaq"
                >
                  <div className="accordion-body">
                    You can reach us by phone at (555) 123-4567, by email at info@aichatassist.com,
                    or by using our live chat feature. Our team is available during business hours
                    to assist you with any questions or concerns.
                  </div>
                </div>
              </div> */}
              <div className="accordion-item border-0 mb-3 shadow-sm">
                <h3 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Do you offer technical support for your products?
                  </button>
                </h3>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#contactFaq"
                >
                  <div className="accordion-body">
                    Yes, we provide comprehensive technical support for all our products. Current
                    customers can access our dedicated support portal or contact our technical team
                    directly at support@aichatassist.com.
                  </div>
                </div>
              </div>
              <div className="accordion-item border-0 mb-3 shadow-sm">
                <h3 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Can I schedule a demo of your AI Chat Assist platform?
                  </button>
                </h3>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#contactFaq"
                >
                  <div className="accordion-body">
                    Absolutely! You can request a demo by emailing support@aichatassist.com One of
                    our product specialists will get in touch to schedule a personalized
                    demonstration.
                  </div>
                </div>
              </div>
              <div className="accordion-item border-0 mb-3 shadow-sm">
                <h3 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    What are your business hours?
                  </button>
                </h3>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#contactFaq"
                >
                  <div className="accordion-body">
                    Our office is open Monday through Friday from 9:00 AM to 6:00 PM, and Saturday
                    from 10:00 AM to 2:00 PM. We are closed on Sundays and major holidays.
                  </div>
                </div>
              </div>
              <div className="accordion-item border-0 mb-3 shadow-sm">
                <h3 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    How quickly will I receive a response to my inquiry?
                  </button>
                </h3>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#contactFaq"
                >
                  <div className="accordion-body">
                    We aim to respond to all inquiries within 24 hours during business days. For
                    urgent matters, please use our live chat feature or call our support line
                    directly for immediate assistance.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Removed inline styles since they're now in Contact.css */}
    </>
  );
}

export default Contact;
